import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad0323a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-card" }
const _hoisted_2 = { class: "game-card-stuff" }
const _hoisted_3 = { class: "game-card-title" }
const _hoisted_4 = {
  key: 0,
  class: "game-card-desc"
}
const _hoisted_5 = { class: "game-subtitle" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Started:", -1))
const _hoisted_7 = { class: "game-subtitle" }
const _hoisted_8 = ["alt", "src"]
const _hoisted_9 = {
  key: 1,
  class: "game-card-desc"
}
const _hoisted_10 = { class: "game-subtitle" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Started:", -1))
const _hoisted_12 = { class: "game-subtitle" }


import { GameData } from '@/models/data'

export default /*#__PURE__*/_defineComponent({
  __name: 'GameCard',
  props: {
    game: null,
    left: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  game: GameData,
  left: boolean
}





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.game.name), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["game-card-content", __props.left ? 'left' : 'right'])
      }, [
        (!__props.left)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(__props.game.start), 1)
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(__props.game.quip), 1),
              _createElementVNode("div", null, _toDisplayString(__props.game.desc), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("img", {
          class: "game-card-img",
          alt: __props.game.img,
          src: require('../assets/games/' + __props.game.img + '.png')
        }, null, 8, _hoisted_8),
        (__props.left)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(__props.game.start), 1)
              ]),
              _createElementVNode("div", _hoisted_12, _toDisplayString(__props.game.quip), 1),
              _createElementVNode("div", null, _toDisplayString(__props.game.desc), 1)
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}
}

})